import { createAsyncThunk } from "@reduxjs/toolkit";
import { type AxiosResponse } from "axios";
import { awsClientGateway } from "./common/gateway";
import { clientLog } from "./logging";
import { logMessage } from "../utils/amplifyLogger";

export interface TestSmsPayload {
  to: string[];
  message: string;
  language: string;
  includeFooter: boolean;
  senderNumber: string;
}

interface SmsRequest {
  destinationNumber: string;
  messageBody: string;
  language: string;
  includeFooter: boolean;
  senderNumber: string;
  apiToSqs: boolean;
}

/**
 * Enqueue a test SMS message for the given instance
 * Expects body: { to, message, language, includeFooter, senderNumber }
 */
export const sendTestSms = createAsyncThunk<
  AxiosResponse | unknown,
  TestSmsPayload
>(
  "testSms/sendTestSms",
  async (payload: TestSmsPayload, { rejectWithValue }) => {
    try {
      const { to, message, language, includeFooter, senderNumber } = payload;

      // 'to' is an array of phone numbers, join multiple numbers into a single string
      const smsRequest: SmsRequest = {
        destinationNumber: to.join(","),
        messageBody: message,
        language,
        includeFooter,
        senderNumber,
        apiToSqs: true,
      };

      const response = await awsClientGateway({
        pathTemplate: `/invokeSms`,
        method: "POST",
        body: smsRequest,
      });

      return response;
    } catch (error) {
      clientLog({
        component: `testSms`,
        message: `Something went wrong in sendTestSms API => ${error}`,
      });
      logMessage(
        `testSms`,
        `Something went wrong in sendTestSms API => ${error}`,
        `error`,
      );
      return rejectWithValue("Error in sendTestSms api endpoint");
    }
  },
);
